import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
interface OrgStoreState {
  organisation: {
    emailDomains: string[];
    hasBrokers: boolean;
    logoUrl: string;
    name: string;
    organisationId: string;
    primaryColour: string;
    status: string;
  };
  setOrg: (org: any) => void;
}

const organisation = {
  emailDomains: [],
  hasBrokers: true,
  logoUrl: '',
  name: '',
  organisationId: '',
  primaryColour: '',
  status: ''
};
export const useOrgStore = create<OrgStoreState>()(
  devtools(
    persist(
      (set) => ({
        organisation,
        setOrg: (org) => set({ organisation: org })
      }),
      {
        name: 'org',
        storage: createJSONStorage(() => sessionStorage)
      }
    )
  )
);
